import { Language } from 'interfaces/Language'
import {
    adsSurveyRedirectRoute,
    appChatRoute,
    appCreateKnowsRoute,
    appEditProfileRoute,
    appFeedsRoute,
    appFlashcardsRoute,
    appLibraryRoute,
    appMyKnowsRoute,
    profilePayoutsCompetitionFormRoutePattern,
    profilePayoutsCompetitionRoutePattern,
    appPayoutsHistoryRoute,
    appPayoutsRequestRoute,
    appPayoutsRoute,
    appSearchRoute,
    appSubjectsKnowsRoute,
    appUnavailableFeatureRoute,
    chatsRedirectRoute,
    learningBotRedirectRoute,
    pollsRedirectRoute,
    proPlanActivateRoute,
    userTopicQuizRedirectRoute,
    usersRedirectRoute,
    appSchoolGptRoute,
    appCreateKnowsDetailsRoute,
    appOnboardingRoute,
} from './routes'
import { getCookieConsent } from 'lib/tracking/storage'

export function getLandingPageSlugs(locale: Language) {
    switch (locale) {
        case Language.German:
        case Language.French:
        case Language.Polish:
        case Language.BritishEnglish:
        case Language.Italian:
        case Language.AmericanEnglish:
        case Language.Spanish:
        case Language.ArgentineSpanish:
        case Language.ChileanSpanish:
        case Language.ColombianSpanish:
        case Language.PeruvianSpanish:
        case Language.Turkish:
        case Language.MexicanSpanish:
        case Language.Greek:
        case Language.Romanian:
        case Language.BrazilianPortuguese:
        case Language.Czech:
        case Language.Portuguese:
        case Language.Filipino:
        case Language.Hungarian:
        case Language.Dutch:
            return [
                'advertise',
                'download',
                'pro-plan',
                'checkout',
                'success',
                'activate',
                'download',
                'profile',
                'company',
                'knowunity-ai',
                'university',
                'ai-summary',
                'uni-gpt',
                'mock-exam',
                'signin',
                'signup',
                'confirm',
                'reset-password',
                'forgot-password',
                'careers',
                'search',
                'subjects',
                'working-at-knowunity',
                'parent',
                'safety',
            ]
        default:
            throw new Error(`Unknown language: ${locale}`)
    }
}

export const isSeoKnowPage = (pathname: string) => {
    const knowPagesPathnames = [
        '/knows/[slug]',
        '/knows/u/[slug]',
        '/topics/[topicLevelOne]',
        '/topics/[topicLevelOne]/[topicLevelThree]',
        '/legal/[slug]',
        '/subjects/[slug]',
        '/knowledge',
        '/knowledge/[areaSlug]',
        '/knowledge/[areaSlug]/[domainSlug]',
        '/knowledge/[areaSlug]/[domainSlug]/[itemSlug]',
    ]
    return !!knowPagesPathnames.includes(pathname)
}

export function getPagesWithoutNavbarAndFooter() {
    return [
        appFeedsRoute,
        appSearchRoute,
        '/app/knows/[slug]',
        appUnavailableFeatureRoute,
        appMyKnowsRoute,
        appChatRoute,
        appLibraryRoute,
        appFlashcardsRoute,
        appEditProfileRoute,
        appSubjectsKnowsRoute,
        appCreateKnowsRoute,
        appPayoutsRoute,
        appPayoutsHistoryRoute,
        appPayoutsRequestRoute,
        `/app/library/[slug]`,
        proPlanActivateRoute,
        profilePayoutsCompetitionRoutePattern,
        profilePayoutsCompetitionFormRoutePattern,
        // redirects
        learningBotRedirectRoute,
        adsSurveyRedirectRoute,
        pollsRedirectRoute,
        chatsRedirectRoute,
        userTopicQuizRedirectRoute,
        usersRedirectRoute,
        '/pro-plan/paypal-redirect',
        appSchoolGptRoute,
        appCreateKnowsDetailsRoute,
        appOnboardingRoute,
        '/app/knowers/[slug]/profile',
        '/app/ai-summary',
        '/app/ai-mock-exam',
        '/pro-plan/congratulation',
        '/pro-plan/congratulation-paddle',
        '/ai-chats/parent-accesses/[uuid]',
        '/marketing-onboarding',
        '/payout-test',
    ]
}

export const shouldEnableClarityForMinorityOfUsers = () => {
    if (typeof window === 'undefined') return false

    const cookieConsent = getCookieConsent()
    if (!cookieConsent?.statistics) {
        return false
    }
    return Math.random() < 0.1
}
